import { authUtils } from "@/scripts/authUtils.js";

/**
 * Mixin for public pages that signed-in users must be able to read (the
 * legal pages the paywall links to, per App Store Guideline 3.1.2, and the
 * account-deletion instructions). Hydrates authStore so AppNavigation shows
 * the signed-in state, but, unlike authSetupMixin, never redirects. It does
 * not seed the first-sign-in profile: the sign-in call sites in authUtils.js
 * do that for every page. It only finishes a seed that a reload interrupted
 * (see setupAuthPresence).
 *
 * Usage: Add to component's mixins array
 * Example: mixins: [authPresenceMixin]
 */
export const authPresenceMixin = {
  data() {
    return {
      authPresenceUnsubscribe: null,
    };
  },
  mounted() {
    this.authPresenceUnsubscribe = authUtils.setupAuthPresence();
  },
  beforeUnmount() {
    if (this.authPresenceUnsubscribe) {
      this.authPresenceUnsubscribe();
    }
  },
};
